import { apolloClient } from "@/plugins/vue-apollo.js";

const createBooking = (_variables, input, filter) => {
  // , limit, skip
  let responseFromApi;
  let variables = _variables;

  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/bookings/api/mutations/create_booking.graphql"),
      variables: variables,
      update: (store, { data }) => {
        const query = {
          query: require("@/bookings/api/queries/booking_query.graphql"),
          variables: {
            input: input,
            filter: filter
          }
        };
        let allBookings = store.readQuery(query);
        allBookings.getBookings.bookings.unshift(data.createBooking); //push to top
        store.writeQuery({
          ...query,
            data: allBookings,
        });
      }
    })
    .catch(error => {
      return error;
    });
  return responseFromApi;
};
export { createBooking };
